<template>
  <div v-if="i18nLoaded" class="main">
    <div class="side-bar">
      <Media :query="{ maxWidth: 1152 }">
        <SideBar :isWide="false" />
      </Media>
      <Media :query="{ minWidth: 1152 }" @media-enter="setWide(true)" @media-leave="setWide(false)">
        <SideBar :isWide="true" />
      </Media>
    </div>
    <div class="main-contents" :class="{ wide: isWide }">
      <UserInfo />
      <section class="section">
        <CommonHeader v-if="displayTitle" :title="title" :subTitle="subTitle">
          <template slot="leftElements">
            <slot name="leftElements" />
          </template>
          <template slot="rightElements">
            <slot name="rightElements" />
          </template>
        </CommonHeader>
        <slot name="content" />
      </section>
      <Footer />
    </div>
  </div>
</template>

<script>
import Media from "vue-media";
import CommonHeader from "@/components/shared/CommonHeader";
import SideBar from "@/components/shared/SideBar";
import UserInfo from "@/components/shared/UserInfo";
import Footer from "@/components/shared/Footer";
import { mapGetters } from "vuex";

export default {
  components: {
    Media,
    SideBar,
    UserInfo,
    CommonHeader,
    Footer,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      default: "",
    },
    displayTitle: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isWide: window.innerWidth > 1152,
    };
  },
  computed: {
    ...mapGetters({
      i18nLoaded: "i18n/i18nLoaded",
    }),
  },
  methods: {
    setWide(isWide) {
      this.isWide = isWide;
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  min-height: 100vh;

  .side-bar {
    position: fixed;
    height: 100%;
  }

  .main-contents {
    width: 100%;
    padding-left: 130px;

    .section {
      padding-top: 90px;
      padding-right: 78px;
    }

    &.wide {
      padding-left: 220px;
    }
  }
}
</style>
